import { render, staticRenderFns } from "./BlipReportsTable.vue?vue&type=template&id=6ef0eaa0&scoped=true&"
import script from "./BlipReportsTable.vue?vue&type=script&lang=js&"
export * from "./BlipReportsTable.vue?vue&type=script&lang=js&"
import style0 from "./BlipReportsTable.vue?vue&type=style&index=0&id=6ef0eaa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef0eaa0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib'
installComponents(component, {VDataTable})
